import React, { Component } from "react";
import AreaDetails from "./AreaDetails.jsx";
import AttendanceDetails from "./AttendanceDetails.jsx";
import AttendanceRuleDetails from "./AttendanceRuleDetails.jsx";
import CompanyDetails from "./CompanyDetails.jsx";
import DepartmentDetails from "./DepartmentDetails.jsx";
import EmployeeTypeDetails from "./EmployeeTypeDetails.jsx";
import HolidaysDetails from "./HolidaysDetails.jsx";
import PagIbigDetails from "./PagIbigDetails.jsx";
import PayscaleDetails from "./PayscaleDetails.jsx";
import PerformanceDetails from "./PerformanceDetails.jsx";
import PHICDetails from "./PHICDetails.jsx";
import PositionDetails from "./PositionDetails.jsx";
import SSSDetails from "./SSSDetails.jsx";
import IncomeTaxDetails from "./IncomeTaxDetails.jsx";
import PayLevelDetails from "./PayLevelDetails.jsx";

class DatabaseDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collection: null,
            instanceId: null
        }
    }

    componentDidMount() {
        const { match } = this.props;
        if(match.params.collection && match.params.id) {
            this.setState({
                collection: match.params.collection,
                instanceId: match.params.id
            })
        }
    }

    goBack = () => {
        this.props.history.goBack()
    }

    goToList = (collection, id) => {
        let link;
        if (collection && id) {
            link = `/database/list/${collection}/${id}`
        } else if (collection) {
            link = `/database/list/${collection}`
        } else {
            link = `/database/list`
        }
        this.props.history.push(link)
    }

    goToEditForm = (collection, id) => {
        this.props.history.push(`/database/edit/${collection}/${id}`)
    }

    render() {

        const { 
            collection,
            instanceId
        } = this.state;

        return (
        <div className="content">
            {collection === "area" &&
                <AreaDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "attendance" &&
                <AttendanceDetails instanceId={instanceId} goToList={this.goToList} goBack={this.goBack} goToEditForm={this.goToEditForm} />
            }
            {collection === "attendance-rule" &&
                <AttendanceRuleDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "company" &&
                <CompanyDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "department" &&
                <DepartmentDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "employeeType" &&
                <EmployeeTypeDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "holidays" &&
                <HolidaysDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "payscale" &&
                <PayscaleDetails instanceId={instanceId} goToList={this.goToList} goBack={this.goBack}  goToEditForm={this.goToEditForm} />
            }
            {collection === "performance" &&
                <PerformanceDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "phic" &&
                <PHICDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "position" &&
                <PositionDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "sss" &&
                <SSSDetails instanceId={instanceId} goToList={this.goToList} goBack={this.goBack} goToEditForm={this.goToEditForm} />
            }
            {collection === "pag-ibig" &&
                <PagIbigDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "pay-level" &&
                <PayLevelDetails instanceId={instanceId} goToList={this.goToList} goToEditForm={this.goToEditForm} />
            }
            {collection === "income-tax" &&
                <IncomeTaxDetails instanceId={instanceId} goToList={this.goToList} goBack={this.goBack} goToEditForm={this.goToEditForm} />
            }
        </div>
        );
    }
}

export default DatabaseDetails;
